
$(function () {


    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function () {
        window.history.pushState(null, document.title, window.location.href);
    });

    const TODAY_LOCAL = new Date(); 

    const month = String(TODAY_LOCAL.getMonth() + 1).padStart(2, '0'); 
    const day = String(TODAY_LOCAL.getDate()).padStart(2, '0'); 
    const year = TODAY_LOCAL.getFullYear();

    const todayMDY = `${month}/${day}/${year}`;
    const todayYMD = `${year}-${month}-${day}`;

    const UNEXPECTED_ERROR_MESSAGE = "We're sorry, something went wrong while looking up the application for catastrophic tax refund. Please try again later or contact the Appraisal Department at 941-748-8208 for assistance.";
    const formErrorMessage = document.getElementById('form-error-message');
    if (formErrorMessage)
        formErrorMessage.textContent = UNEXPECTED_ERROR_MESSAGE;

    let timeoutID; 

    let isValid_Parid = false;
    let last_valid_parid = "";

    const form = document.getElementById("pao_catastrophic_event_status_form");
    const parcelId = document.getElementById('pao_parcel_id');
    const validationError = document.querySelector(".validation-error");
    const resultsBody = document.querySelector(".catastrophic-event-status-results-body");

    const dirtyFields = {
        parcelId: false
    };    

    function setStatusPlaceholder() {
        resultsBody.innerHTML = "Application status will be shown here.";
    }
    setStatusPlaceholder();


    form.addEventListener('reset', function () {
        resetValidation(this);
    });

    parcelId.addEventListener('input', () => {
        dirtyFields.parcelId = true;
        parcelId.classList.remove("is-valid", "is-invalid");
    });

    parcelId.addEventListener('blur', () => {
        const paridError = document.querySelector('.parid-error');
        const paridLabel = document.querySelector('label[for="pao_parcel_id"]');
        const valid = isParcelIdValid();

        validateField(parcelId, valid, dirtyFields.parcelId);

        if (valid) {

            if (paridError) {
                paridError?.classList.remove('is-invalid');
                paridError.style.display = 'none';
            }

        } else {

            clearTypeaheadSuggestionFields();

                        if (dirtyFields.parcelId) {
                if (paridError) {
                    paridError.innerHTML = '<i class="fas fa-exclamation-circle"></i> A Parcel Id is required.';
                    paridError?.classList.add('is-invalid');
                    paridError.style.display = 'block';
                }
            }
        }

        if (paridLabel) {
            paridLabel.classList.toggle("valid", valid);
            paridLabel.classList.toggle("invalid", !valid && dirtyFields.parcelId);
        }
    });


    parcelId.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
            event.preventDefault(); 
        }
    });


    $(parcelId).typeahead(
        {
            hint: true,
            highlight: true,
            minLength: 3,  
        },
        {
            name: 'suggestions',
            limit: 5, 
            source: function (query, syncResults, asyncResults) {
                if (query.length >= 3) {
                    clearTimeout(timeoutID); 
                    timeoutID = setTimeout(function () {
                        lookupParid(query, asyncResults);  
                    }, 300); 
                } else {
                    asyncResults([]);  
                }
            },
            display: function (item) {
                return item.PARID;  
            },
            templates: {
                suggestion: function (data) {
                    return `
                    <div class="pao-tt-suggestion" role="listbox" aria-live="polite" aria-label="Search suggestions">
                      <div class="pao-tt-item" role="option" aria-selected="false">
                        <div><strong>Parcel Id:</strong> ${data.PARID}</div> 
                        <div><strong>Owner:</strong> ${data.OWNER}</div> 
                        <div><strong>Situs Address:</strong> ${data.SITUS}</div>
                      </div>
                    </div>`;
                }
            }
        }
    );

    $(parcelId).on('typeahead:selected', function (event, suggestions) {
        setTypeaheadSuggestionFields(suggestions);

        if (last_valid_parid?.length > 0) {
            setStatusPlaceholder();
            lookupStatusByParid(last_valid_parid);            
        }        
    });

    $(parcelId).on('focus', function () {
        var inputWidth = $(this).outerWidth();
        setTimeout(function () {
            $('.tt-menu').css('width', inputWidth); 
        }, 50); 
    });

    $(parcelId).on('typeahead:close', function () {
        parcelId.value = last_valid_parid;
    });

    $(parcelId).on('typeahead:change', function (event, query) {
        if (!(query?.length > 0)) {
            parcelId.value = "";
            clearTypeaheadSuggestionFields();
        }
    });


    function isParcelIdValid() {
        const parid = Array.isArray(last_valid_parid)
            ? last_valid_parid[0]
            : last_valid_parid;

        return typeof parid === 'string' && parid.length > 9 && isNumeric(parid);
    }

    function validateField(el, condition, isDirty) {
        if (!isDirty) {
            el.classList.remove("is-valid", "is-invalid");
        } else {
            el.classList.toggle("is-valid", condition);
            el.classList.toggle("is-invalid", !condition);
        }
    }


    function resetValidation(form) {
        if (!form || !(form instanceof HTMLFormElement)) {
            return;
        }

                clearTypeaheadSuggestionFields();

        $(parcelId).typeahead("val", "");
        $(parcelId).typeahead("close");  

        form.reset();

        form.classList.remove('was-validated');

        for (const key in dirtyFields) {
            dirtyFields[key] = false;
            const el = form.querySelector(`[name="${key}"]`);
            if (el) validateField(el, false, false);
        }      

        form.querySelectorAll('.invalid-feedback, .valid-feedback, .input-warning').forEach(feedback => {
            feedback.style.display = 'none';
        });

        parcelId.classList.remove("is-valid", "is-invalid");

        setStatusPlaceholder();

        const elementsToHide = [
            'form-error-message',
            'validation-error-message',
            'error-message',
            'pao-unsafe-file-list'
        ];

        elementsToHide.forEach(id => {
            const el = document.getElementById(id);
            el?.classList.add('d-none');
            el?.setAttribute('aria-hidden', 'true');
        });

        const errorMessages = document.querySelectorAll('.invalid-feedback, .parid-error, .input-warning');
        errorMessages.forEach(el => {
            el?.classList.remove('d-block');
        });
    }

    function showDefaultErrorMessage() {
        formErrorMessage.classList.add('alert-danger');
        formErrorMessage.classList.remove('d-none');
        formErrorMessage.setAttribute('aria-hidden', 'false');
    }

    function hideDefaultErrorMessage() {
        formErrorMessage.classList.remove('alert-danger');
        formErrorMessage.classList.add('d-none');
        formErrorMessage.setAttribute('aria-hidden', 'true');
    }

    function clearTypeaheadSuggestionFields() {
        isValid_Parid = false;
        last_valid_parid = "";      
    }

    function setTypeaheadSuggestionFields(suggestions) {
        try {
            isValid_Parid = true;
            last_valid_parid = suggestions.PARID;            
            if (parcelId.value !== suggestions.PARID)
                parcelId.value = suggestions.PARID;
        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    function lookupParid(lu_value, asyncResults) {
        try {       
            const isNumeric = !/[^0-9]/.test(lu_value);
            const obj = {
                job: "parid_search",
                findBy: isNumeric ? "findby-number" : "findby-name",
                findText: lu_value,
                rollType: 'R'
            };

            const json = JSON.stringify(obj);


            const url = `${window.PAOPATH.theme}/models/pao-model-find-parid.php`;
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: 'Request=' + encodeURIComponent(json)
            })
                .then(response => response.json())
                .then(data => {
                    let suggestions = null;
                    if (Array.isArray(data)) {
                        if (data?.length === 1) {
                            suggestions = data.reduce((acc, item) => {
                                acc.PARID.push(item.PARID);
                                acc.OWNER.push(item.OWNER);
                                acc.SITUS.push(item.SITUS);
                                acc.MAILING.push(item.MAILING);
                                return acc;
                            }, { PARID: [], OWNER: [], SITUS: [], MAILING: [] });

                            setTypeaheadSuggestionFields(suggestions);
                        } else {
                            clearTypeaheadSuggestionFields();
                        }
                        asyncResults(data);
                    } else if (Array.isArray(data.items)) {
                        suggestions = data.map(item => [item.PARID, item.OWNER, item.SITUS, item.MAILING]);
                        asyncResults(suggestions);
                    } else {
                        asyncResults([]);  
                    }
                })
                .catch(error => {
                    showDefaultErrorMessage();
                    asyncResults([]);
                });
        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    function lookupStatusByParid(parid, asyncResults) {
        try {       
            const isNumeric = !/[^0-9]/.test(parid);
            if (!isNumeric)
                return;

            if (Array.isArray(parid)) {
                parid = parid[0];
            }

            const obj = {
                parid: parid
            };

            const json = JSON.stringify(obj);


            const url = `${window.PAOPATH.theme}/models/pao-model-catastrophic-event-status.php`;
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: 'Request=' + encodeURIComponent(json)
            })
                .then(response => response.json())
                .then(result => {

                    if (result?.status_msg === 'error') {

                        const er = window.isTestModeActive && result?.message
                            ? result.message
                            : showDefaultErrorMessage;

                        formErrorMessage.textContent = er;
                        formErrorMessage.classList.add('alert-danger');
                        formErrorMessage.classList.remove('d-none');
                        formErrorMessage.setAttribute('aria-hidden', 'false');
                        document.getElementById("errorblock").scrollIntoView({
                            behavior: "smooth"  
                        });

                    } else {

                        const message_raw = result?.status_msg ?? `No Application for Catastrophic Event Tax Refund found for parcel #${parid}`;                       
                        const el = document.querySelector(".catastrophic-event-status-results");
                        el.classList.remove("d-none");
                        el.setAttribute("aria-hidden", "false");

                        const body = document.querySelector(".catastrophic-event-status-results-body");

                        let message = message_raw.replace(/\b(IN-PROCESS|APPROVED|DENIED)\b/g, (match) => {
                            const map = {
                                "APPROVED": "text-success",
                                "IN-PROCESS": "text-primary",
                                "DENIED": null
                            };

                            let formatted = match
                                .toLowerCase()                
                                .replace(/\b\w/g, c => c.toUpperCase()); 

                            const cls = map[match];
                            return cls ? `<span class="${cls}">${formatted}</span>` : formatted;
                        });

                                            body.innerHTML = message;

                        body.classList.remove("trans-font");
                        void body.offsetWidth; 
                        body.classList.add("trans-font");
                    }                    
                })
                .catch(error => {
                    showDefaultErrorMessage();
                });
        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    function isNumeric(str) {
        return !isNaN(str) && !isNaN(parseFloat(str));
    }

    const engine = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        local: [],  
    });

    function debounced(delay, fn) {
        let timerId;
        return function (...args) {
            if (timerId) {
                clearTimeout(timerId);
                n = 0;
            }
            timerId = setTimeout(() => {
                fn(...args);
                timerId = null;
            }, delay);
        }
    }   
});